module.exports = __webpack_public_path__ + "img/journal_file_delete.35446e6a.svg";